<script setup>
/**
 * @fileoverview Dialog component based on shadcn-vue
 * @description Modal dialog with overlay
 * @example
 * <Dialog>
 *   <DialogTrigger>Open</DialogTrigger>
 *   <DialogContent>
 *     <DialogHeader>
 *       <DialogTitle>Title</DialogTitle>
 *       <DialogDescription>Description</DialogDescription>
 *     </DialogHeader>
 *   </DialogContent>
 * </Dialog>
 */
import { DialogRoot } from 'radix-vue'

const props = defineProps({
  open: {
    type: Boolean,
    default: undefined
  },
  defaultOpen: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:open'])
</script>

<template>
  <DialogRoot :open="open" :default-open="defaultOpen" @update:open="emit('update:open', $event)">
    <slot />
  </DialogRoot>
</template>
